export default "__VITE_ASSET__Dpy5ZP4m__"